import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "./page-breadcrumb.css";

export type PageBreadcrumbItem = {
    label: string;
    to?: string;
};

type PageBreadcrumbProps = {
    items: PageBreadcrumbItem[];
};

export const PageBreadcrumb = ({ items }: PageBreadcrumbProps) => {
    const visibleItems = items.filter((item) => item.label);

    if (visibleItems.length === 0) {
        return null;
    }

    return (
        <nav className="page-breadcrumb" aria-label="Breadcrumb">
            {visibleItems.map((item, index) => {
                const isLastItem = index === visibleItems.length - 1;

                return (
                    <span className="page-breadcrumb-item" key={`${item.label}-${index}`}>
                        {item.to && !isLastItem ? (
                            <Link to={item.to}>{item.label}</Link>
                        ) : (
                            <span aria-current={isLastItem ? "page" : undefined}>{item.label}</span>
                        )}

                        {!isLastItem && (
                            <NavigateNextIcon className="page-breadcrumb-separator" aria-hidden="true" />
                        )}
                    </span>
                );
            })}
        </nav>
    );
};
